import { render, staticRenderFns } from "./puishment-demo.vue?vue&type=template&id=372248e8&scoped=true&"
import script from "./puishment-demo.vue?vue&type=script&lang=js&"
export * from "./puishment-demo.vue?vue&type=script&lang=js&"
import style0 from "./puishment-demo.vue?vue&type=style&index=0&id=372248e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372248e8",
  null
  
)

export default component.exports